function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "prefix__a",
  d: "M.476 17.78c0 9.692 8.293 17.55 18.524 17.55 10.232 0 18.525-7.857 18.525-17.55C37.525 8.086 29.232.23 19 .23S.476 8.087.476 17.78"
}), React.createElement("path", {
  id: "prefix__c",
  d: "M.476 17.78c0 9.692 8.293 17.55 18.524 17.55 10.232 0 18.525-7.857 18.525-17.55C37.525 8.086 29.232.23 19 .23S.476 8.087.476 17.78"
}), React.createElement("path", {
  id: "prefix__e",
  d: "M.476 17.78c0 9.692 8.293 17.55 18.524 17.55 10.232 0 18.525-7.857 18.525-17.55C37.525 8.086 29.232.23 19 .23S.476 8.087.476 17.78"
}), React.createElement("path", {
  id: "prefix__g",
  d: "M.476 17.78c0 9.692 8.293 17.55 18.524 17.55 10.232 0 18.525-7.857 18.525-17.55C37.525 8.086 29.232.23 19 .23S.476 8.087.476 17.78"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FC3A52",
  d: "M36 18c0 9.942-8.058 18-18 18S0 27.942 0 18 8.058 0 18 0s18 8.058 18 18"
}), React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#prefix__a"
})), React.createElement("path", {
  fill: "#FFF",
  d: "M17.236 24.349c-.09.112-.225.182-.375.194-.223.017-.768.053-1.425.053-1.197 0-2.764-.12-3.422-.695-.246-.214-.377-.485-.377-.78l.002-.452c-.107.023-.222.013-.327-.033l-1.902-.824c-.044-.02-.075-.053-.111-.08-2.624 1.357-2.955 2.414-2.97 2.815-.017.477.336.758.549.882 1.06.62 5.375 2.181 9.905 1.74 1.194-.118 2.727-.348 4.004-1.101 2.514-1.48 4.065-2.206 5.722-2.675 3.066-.87 4.032-2.383 3.926-3.415-.043-.416-.266-.721-.549-.789-.156.28-.328.55-.536.805-1.84 2.244-5.668 3.43-11.698 3.621-.055-.002-.094-.003-.137-.013-.057.34-.142.576-.28.747",
  mask: "url(#prefix__b)"
}), React.createElement("mask", {
  id: "prefix__d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#prefix__c"
})), React.createElement("path", {
  fill: "#FFF",
  d: "M24.76 10.058c.418-.308.408-.912-.048-1.167-.606-.339-1.025-.497-1.04-.502-.002 0-.027-.006-.072-.006-.306 0-1.556.228-3.817 3.339-1.976 2.719-2.075 6.888-2.14 9.645-.012.49-.067 1.258-.062 1.258 5.7-.18 9.305-1.24 10.944-3.239 1.002-1.22 1.266-2.773.808-4.745-.425-1.834-1.432-3.204-2.481-4.188-.22-.205-.565-.262-.835-.122-3.708 1.926-3.762 7.838-3.762 7.899 0 .248-.211.45-.475.45-.262 0-.475-.202-.475-.45 0-.258.056-5.675 3.456-8.172",
  mask: "url(#prefix__d)"
}), React.createElement("g", null, React.createElement("mask", {
  id: "prefix__f",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#prefix__e"
})), React.createElement("path", {
  fill: "#FFF",
  d: "M17.796 8.398c-.046.016-5.095 1.837-5.114 14.65 0 .044.016.088.052.114.56.41 2.304.487 3.626.42.062-.003.11-.04.12-.097.077-.454.1-1.34.118-2.14.069-2.877.171-7.222 2.324-10.185 1.979-2.723 1.667-2.314 1.96-2.78.055-.088-.01-.202-.117-.196-.724.04-2.78.156-2.969.214",
  mask: "url(#prefix__f)"
})), React.createElement("g", null, React.createElement("mask", {
  id: "prefix__h",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#prefix__g"
})), React.createElement("path", {
  fill: "#FFF",
  d: "M11.97 12.045c-1.053 1.575-2.597 5.41-2.096 8.932l1.334.526c.216.093.458-.058.466-.28.299-7.296 2.297-10.784 3.868-12.414-1.025.444-2.318 1.361-3.572 3.236",
  mask: "url(#prefix__h)"
})), React.createElement("g", {
  fill: "#FC3A52"
}, React.createElement("path", {
  d: "M6.945 14.695c2.808 0 5.152-2.736 5.152-6.15 0-2.448-1.39-4.402-3.598-4.402H6.455L4.9 14.695h2.045zM2.665.808c.028-.26.272-.495.518-.495h6.08c4.307 0 7.387 3.882 7.387 7.92 0 5.654-4.307 10.317-10.06 10.317H.484c-.245 0-.41-.235-.354-.495L2.664.808zM34.91 8.702c0-2.45-1.526-4.481-3.706-4.481-2.645 0-5.208 2.736-5.208 5.966 0 2.423 1.527 4.455 3.68 4.455 2.7 0 5.235-2.71 5.235-5.94M31.776.052c4.226 0 7.606 3.648 7.606 8.155 0 5.863-4.526 10.604-10.25 10.604-4.199 0-7.607-3.595-7.607-8.076 0-5.889 4.58-10.683 10.251-10.683M46.9.521c.027-.26.3-.468.545-.468h.6l8.124 10.056h.028L57.505.808c.028-.261.246-.494.518-.494h3.326c.246 0 .464.207.436.442l-2.563 17.586c-.027.26-.272.469-.516.469h-.683L49.9 8.44h-.027l-1.228 9.613c-.053.262-.272.496-.545.496h-3.352c-.218 0-.436-.208-.41-.443L46.9.521zM69.332.808c.027-.26.272-.495.518-.495h10.278c.272 0 .436.234.409.495l-.437 2.84c-.027.26-.245.495-.517.495h-6.49l-.49 3.23h5.289c.245 0 .436.234.41.495l-.437 2.84c-.055.287-.3.495-.546.495h-5.262l-.517 3.517h6.488c.274 0 .409.235.382.496l-.408 2.839c-.028.26-.273.496-.545.496H67.178c-.272 0-.437-.236-.381-.496L69.332.808zM84.322 15.815l.436-.443c.327-.313.572-.443.873-.131.381.417 1.662 1.825 3.925 1.825 1.827 0 3.544-1.486 3.544-3.153 0-1.642-1.281-2.606-3.544-3.856-2.18-1.199-3.653-2.345-3.653-4.741 0-2.19 1.445-5.264 5.916-5.264 2.644 0 3.98 1.147 4.225 1.329.137.104.382.39.028.886l-.3.417c-.3.339-.573.495-.9.235-.573-.444-1.936-1.12-3.245-1.12-2.48 0-3.652 1.98-3.652 3.282 0 1.46 1.035 2.423 2.753 3.308 2.618 1.355 4.608 2.632 4.608 5.315 0 2.892-2.182 5.107-5.971 5.107-3.054 0-4.825-1.928-5.098-2.24-.164-.21-.3-.418.055-.756M104.246.938c.055-.339.328-.625.682-.625h.927c.327 0 .572.286.517.625l-1.09 7.373 8.56-7.737c.11-.131.355-.26.491-.26h1.417c.436 0 .736.442.301.832l-8.888 7.972 6.461 8.754c.164.183.081.678-.464.678h-1.307c-.165 0-.383-.104-.41-.182l-6.352-8.729-1.226 8.286c-.056.339-.355.625-.682.625h-.927c-.354 0-.545-.286-.518-.625L104.246.938zM122.833.808c.028-.26.273-.495.52-.495h1.198c.246 0 .436.234.382.495l-2.536 17.247c-.027.26-.272.496-.518.496h-1.199c-.245 0-.436-.236-.382-.496L122.833.808z",
  transform: "translate(45 10)"
})));

var SvgLogoDoneski = function SvgLogoDoneski(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 170,
    height: 36,
    viewBox: "0 0 170 36",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoDoneski, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-doneski.bbc46ff2.svg";
export { ForwardRef as ReactComponent };